import Header from './Header'
import Sidebar from './Sidebar'
import HikoFestQuestion from '../Dashboard/HikoFestQuestion'
import AwardsSurveyModal from '../Dashboard/AwardsSurveyModal'
import BusAgendaModal from '../Dashboard/BusAgendaModal'
import { EVENT_PERIOD_END_UTC, EVENT_PERIOD_START_UTC } from '../Dashboard/busSlots'
import OnboardingSurveyGate from './OnboardingSurveyGate'
import ExitInterviewGate from './ExitInterviewGate'
// import ManagerFeedbackOverdueNotice from './ManagerFeedbackOverdueNotice'
import * as moment from 'moment'

const Base = (props) => {
  const year = new Date().getFullYear()
  const shouldShowHikoFestQuestion = () => {
    const today = new Date()
    const endDate = new Date('2025-09-13')
    return today <= endDate
  }

  const shouldShowAwardsSurvey = () => {
    const now = moment.utc()
    // Start: 00:01 of 08/09/2025 UTC (keep original start time)
    const startDate = moment.utc('2026-06-07 00:01:00')
    // End: 17:00 of 11/09/2025 UTC (updated end time)
    const endDate = moment.utc('2026-06-16 12:59:59')

    return now.isBetween(startDate, endDate, null, '[]') // inclusive of both start and end
  }

  const shouldShowBusAgenda = () => {
    const now = moment.utc()
    const startDate = moment.utc(EVENT_PERIOD_START_UTC)
    const endDate = moment.utc(EVENT_PERIOD_END_UTC)

    return now.isBetween(startDate, endDate, null, '[]')
  }

  return (
    <div className='wrapper'>
      <Header />
      <Sidebar />
      <section className='section-container'>{props.children}</section>
      {shouldShowHikoFestQuestion() && <HikoFestQuestion />}
      {shouldShowAwardsSurvey() && <AwardsSurveyModal />}
      {shouldShowBusAgenda() && <BusAgendaModal />}
      <OnboardingSurveyGate />
      <ExitInterviewGate />
      {/* Temporarily disable the global overdue feedback prompt. */}
      {/* <ManagerFeedbackOverdueNotice /> */}
      <footer className='footer-container'>
        <span>&copy; {year} - Speeex</span>
      </footer>
    </div>
  )
}

export default Base
